document.addEventListener("DOMContentLoaded", function () {
  // Video mute/unmute controls
  var videos = document.querySelectorAll(".video-container video");
  var controls = document.querySelectorAll(".audio-control");
  controls.forEach(function (control, index) {
    var video = videos[index];
    var muteButton = control.querySelector(".mute");
    var unmuteButton = control.querySelector(".unmute");

    control.addEventListener("click", function () {
      if (video.muted) {
        video.muted = false;
        muteButton.style.display = "inline-block";
        unmuteButton.style.display = "none";
      } else {
        video.muted = true;
        muteButton.style.display = "none";
        unmuteButton.style.display = "inline-block";
      }
    });
  });

  // Single video block handling
  var videoEl = document.querySelector(".video-container-one");
  if (videoEl) {
    videoEl.muted = true;
    videoEl.play();

    document.body.addEventListener("mouseover", function () {
      videoEl.muted = false;
      videoEl.play();
    });
  }

  // Slick carousel init
  $(".hair_videos_reviews").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
